export const B2C_POLICIES = {
  names: {
    resetPassword: "b2c_1a_passwordreset_test",
  },
};

export const REDIRECT_ERROR_CODES = {
  forgotPassword: "AADB2C90118",
};

export const SAFETY_BUFFER_SECONDS = 120; // 2 minutes
